/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

import { BridgeCommands } from '../../../src/bridge.commands';

import { Types } from '../../types/index';

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const ShowClientNotifications: BridgeCommands.Command<
    Types.Common.Clientnotification.ShowClientNotificationsParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ClientNotification',
    method: 'ShowClientNotifications',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const ClearNotificationsQueue: BridgeCommands.Command<
    Types.Common.Clientnotification.ClearNotificationsQueueParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ClientNotification',
    method: 'ClearNotificationsQueue',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const DeleteNotification: BridgeCommands.Command<
    Types.Common.Clientnotification.DeleteNotificationParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ClientNotification',
    method: 'DeleteNotification',
    persistent: false
};

export const Clientnotification = {
ShowClientNotifications,
ClearNotificationsQueue,
DeleteNotification
};
